import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import React from 'react';
export default {
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  React
};